import * as echarts from 'echarts';

export default {
  name: 'AeRadar',
  props: {
    title: 'echarts-全局配置',
    id: { type: String, default: () => (`a-e-radar-${Math.random().toString().substring(2)}`) },
    resizeCondition: { type: Array, default: () => ['width', 'transform'] },
    sideBarId: { type: String, default: () => 'container-lt' },
    backgroundColor: { type: String, default: () => '' },
    data: {
      type: Array,
      default: () => [
        {
          name: 'product 1',
          value: [5000, 7000, 12000, 11000, 15000, 14000],
        },
        {
          name: 'product 2',
          value: [4000, 9000, 15000, 15000, 13000, 11000],
        },
        {
          name: 'product 3',
          value: [5500, 11000, 12000, 15000, 12000, 12000],
        }
      ]
    },
    theme: { type: String, default: () => 'macarons' },
    option: { type: Object, default: () => ({}) },
    width: { type: String, default: () => '100%' },
    height: { type: String, default: () => '100%' },
    animationDuration: { type: Number, default: () => 1800 },
    delay: { type: Number, default: () => 1000 },
  },
  data() {
    return {
      charts: null,
    }
  },
  watch: {
    option: {
      deep: true,
      handler() {
        this.create();
      }
    },
    $route() {
      this.create();
    }
  },
  mounted() {
    this.create();
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      const legend = this.data.length > 0 && this.data.map((a, b) => a.label);
      const values = this.data.length > 0 && this.data.map((a, b) => ({
        // TODO
        ...a,
      }));
      const theme = require(`echarts/theme/${this.theme}`);
      this.charts = echarts.init(this.$el, theme && theme != '' ? this.theme : '');
      this.charts.clear();
      this.charts && this.charts.setOption({
        backgroundColor: this.backgroundColor,
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            label: {
            }
          }
        },
        radar: {
          radius: '66%',
          center: ['50%', '42%'],
          splitNumber: 8,
          splitArea: {
            areaStyle: {
              color: 'rgba(127,95,132,.3)',
              opacity: 1,
              shadowBlur: 45,
              shadowColor: 'rgba(0,0,0,.5)',
              shadowOffsetX: 0,
              shadowOffsetY: 15
            }
          },
          indicator: [
            { name: 'Sales', max: 10000 },
            { name: 'Administration', max: 20000 },
            { name: 'Information Techology', max: 20000 },
            { name: 'Customer Support', max: 20000 },
            { name: 'Development', max: 20000 },
            { name: 'Marketing', max: 20000 }
          ]
        },
        legend: {
          left: 'center',
          bottom: '10',
          data: legend,
        },
        series: [{
          type: 'radar',
          symbolSize: 0,
          areaStyle: {
            normal: {
              shadowBlur: 13,
              shadowColor: 'rgba(0,0,0,.2)',
              shadowOffsetX: 0,
              shadowOffsetY: 10,
              opacity: 1
            }
          },
          data: values,
          animationDuration: this.animationDuration,
        }],
        ...this.option,
      });
      let timeout = null;
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      } else {
        timeout = setTimeout(() => {
          addEventListener('resize', () => this.charts && this.charts.resize());
          addEventListener('transitionend', a => this.charts && this.resize(a));
          clearTimeout(timeout);
          timeout = null;
        }, this.delay);
      }
    },
    resize({ propertyName }) {
      this.resizeCondition.includes(propertyName) && this.charts.resize();
    },
    cancel() {
      if (this.charts) {
        removeEventListener('transitionend', this.charts.resize);
        removeEventListener('resize', this.resize);
        this.$nextTick(() => {
          this.charts.dispose();
          this.charts = null;
        });
      }
    },
  },
  render() {
    return <div id={this.id} key={this.id} class="a-echarts" style={{ width: this.width, height: this.height }} />
  }
}